const SDK_VERSION = '7.45.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
